import UserProfilesTable from "./UserProfilesTableV2";

export default function UserProfiles(props) {
  const { onProfileClick, userProfiles, isLoading, showAccessWorkspaces, onModifyUserRole, onDeactivateUser } = props;

  if (isLoading) {
    return null;
  }

  if (!Boolean(userProfiles.length)) {
    return null;
  }

  return (
    <UserProfilesTable
      userProfiles={userProfiles}
      onManageWorkspaceAccess={onProfileClick}
      showAccessWorkspaces={showAccessWorkspaces}
      onModifyUserRole={onModifyUserRole}
      onDeactivateUser={onDeactivateUser}
    />
  );
}
